/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AnyOftaskstemplatesidTaskTemplateActionContent model module.
 * @module model/AnyOftaskstemplatesidTaskTemplateActionContent
 * @version v0.3
 */
export default class AnyOftaskstemplatesidTaskTemplateActionContent {
  /**
   * Constructs a new <code>AnyOftaskstemplatesidTaskTemplateActionContent</code>.
   * @alias module:model/AnyOftaskstemplatesidTaskTemplateActionContent
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AnyOftaskstemplatesidTaskTemplateActionContent</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AnyOftaskstemplatesidTaskTemplateActionContent} obj Optional instance to populate.
   * @return {module:model/AnyOftaskstemplatesidTaskTemplateActionContent} The populated <code>AnyOftaskstemplatesidTaskTemplateActionContent</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AnyOftaskstemplatesidTaskTemplateActionContent();
    }
    return obj;
  }
}
